import links from './links';
import subreddits from './subreddits';

export default {links, subreddits};


// WEBPACK FOOTER //
// ./src/apps/client-reddit/reducers/index.js